import { DriveStep } from 'driver.js';
import { WebTour } from 'types';
import { nextTick } from 'vue';
import { ComposerTranslation } from 'vue-i18n';

export function getTourSteps(
  tourKey: string,
  t: ComposerTranslation,
): DriveStep[] {
  if (tourKey === WebTour.START_PAGE) {
    return [
      {
        element: '#main-content-and-footer',
        popover: {
          title: t('tours.startPage.overView.title'),
          description: t('tours.startPage.overView.description'),
          align: 'center',
        },
      },
      {
        element: '#vf-icon-header',
        popover: {
          title: t('tours.startPage.icons.title'),
          description: t('tours.startPage.icons.description'),
          side: 'bottom',
          align: 'center',
        },
      },
      {
        element: '#language-selection',
        popover: {
          title: t('tours.startPage.language.title'),
          description: t('tours.startPage.language.description'),
          side: 'bottom',
          align: 'center',
        },
      },
      {
        element: '#current-user-icon',
        popover: {
          title: t('tours.startPage.user.title'),
          description: t('tours.startPage.user.description'),
          side: 'bottom',
          align: 'center',
        },
      },
      {
        element: 'user-info',
        popover: {
          title: t('tours.startPage.userInformation.title'),
          description: t('tours.startPage.userInformation.description'),
          side: 'bottom',
        },
        onHighlightStarted: async () => {
          const el = document.getElementById('current-user-icon');
          if (el) {
            el.dispatchEvent(
              new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window,
              }),
            );
          }
          await nextTick();
        },
      },
      {
        element: '#vf-logout-icon',
        popover: {
          title: t('tours.startPage.logout.title'),
          description: t('tours.startPage.logout.description'),
          side: 'bottom',
          align: 'center',
        },
        onHighlightStarted: async () => {
          const el = document.getElementById('vf-logout-icon');
          if (el) {
            el.style.marginRight = '19rem';
          }
        },
        onDeselected: () => {
          const el = document.getElementById('vf-logout-icon');
          if (el) {
            el.style.marginRight = '0';
          }
        },
      },
      {
        element: '#add-project-button',
        popover: {
          title: t('tours.startPage.addProject.title'),
          description: t('tours.startPage.addProject.description'),
        },
      },
      {
        element: '#ddp-project-table',
        popover: {
          title: t('tours.startPage.projectOverView.title'),
          description: t('tours.startPage.projectOverView.description'),
          side: 'top',
          align: 'center',
        },
      },
      {
        element: '.p-datatable-thead',
        popover: {
          title: t('tours.startPage.filterOptions.title'),
          description: t('tours.startPage.filterOptions.description'),
          side: 'top',
          align: 'center',
        },
      },
      {
        element: '#table-reset-filter-button',
        popover: {
          title: t('tours.startPage.resetFilter.title'),
          description: t('tours.startPage.resetFilter.description'),
        },
      },
    ];
  }
  if (tourKey === WebTour.PROJECT_DETAILS) {
    return [
      {
        element: '#main-content-and-footer',
        popover: {
          title: t('tours.projectDetails.overView.title'),
          description: t('tours.projectDetails.overView.description'),
          side: 'top',
          align: 'center',
        },
      },
    ];
  }
  return [];
}
